import { FC, useCallback } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { BitmovinUILoaderProps } from '@/organisms/AngelPlayer'
import { useAngelPlayerAPI } from '@/organisms/AngelPlayer/AngelPlayerContext/AngelPlayerContext'
import { BITMOVIN_UI_PLAYER_VERSION } from '@/organisms/AngelPlayer/BitmovinPlayer/constants'

export const BitmovinUILoader: FC<BitmovinUILoaderProps> = ({
  disableCommunityView = true,
  showContentShareButton = false,
  markers = [],
  player,
}) => {
  const bitmovinBaseCDNURL = `https://images.angelstudios.com/raw/upload/${BITMOVIN_UI_PLAYER_VERSION}/angel-studios/bitmovin`
  const { uiManager, setUIManager } = useAngelPlayerAPI()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const uiConfig = {
    disableCommunityView: disableCommunityView,
    showContentShareButton: showContentShareButton,
    hideCommunityViewToggleButton: false,
    metaData: {
      markers,
    },
  }

  const handleBitmovinPlayerJsOnload = useCallback(() => {
    if (!uiManager) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setUIManager?.(bitmovin?.playerui?.UIFactory.buildDefaultUI(player, uiConfig))
    }
  }, [uiManager, uiConfig, player, setUIManager])

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, minimum-scale=1.0, initial-scale=1, maximum-scale=1.0" />
        <link href={`${bitmovinBaseCDNURL}/css/bitmovinplayer-ui.min.css`} rel="stylesheet" />
        <link href={`${bitmovinBaseCDNURL}/css/bitmovinplayer-ui-remotecontrol.min.css`} rel="stylesheet" />
      </Head>
      <Script
        onReady={handleBitmovinPlayerJsOnload}
        src={`${bitmovinBaseCDNURL}/js/bitmovinplayer-ui.min.js`}
        strategy="afterInteractive"
      />
    </>
  )
}
